import { queryApi } from "lib/api";
import {
    DeliveryReservationParams,
    DeliveryReservationResponse,
    ExternalTokenParams,
    ExternalTokenResponse,
    PickupReservationParams,
    PickupReservationResponse,
} from "./type";

export const callPickupReservationApi = (
    data: PickupReservationParams
): Promise<PickupReservationResponse> => queryApi("mint/order/pickup", data);

export const callDeliveryReservationApi = (
    data: DeliveryReservationParams
): Promise<DeliveryReservationResponse> =>
    queryApi("mint/order/delivery", data);

export const callExternalTokenApi = (
    data: ExternalTokenParams
): Promise<ExternalTokenResponse> => queryApi("mint/account/sign", data);
